import {
  DAVEY_ENV_QA_URL,
  DAVEY_LOG_ROCKET_ID_QA,
  DAVEY_TIMBERTRAP_KEY,
  DAVEY_TIMBERTRAP_URL,
} from '@shared-constants/environment-constants';
import { version } from '@shared-version';

import { IForemanEnvironment } from './environment.d';

export const environment: IForemanEnvironment = {
  environmentName: 'qa',
  environmentNameFull: 'QA',
  appVersion: version,
  application: 'foreman',
  production: false,
  development: false,
  webServerUrl: `${DAVEY_ENV_QA_URL}/`,
  timberTrapUrl: `${DAVEY_TIMBERTRAP_URL}/`,
  timberTrapKey: DAVEY_TIMBERTRAP_KEY,
  logRocketAppId: DAVEY_LOG_ROCKET_ID_QA,
  defaultSupportEmailAddress: 'daveytime@davey.com',
  landingPageUrl: DAVEY_ENV_QA_URL,
};
